import { render } from "./roll_call.vue?vue&type=template&id=6650653e&scoped=true"
import script from "./roll_call.vue?vue&type=script&lang=js"
export * from "./roll_call.vue?vue&type=script&lang=js"

import "./roll_call.vue?vue&type=style&index=0&id=6650653e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6650653e"]])

export default __exports__